module.exports = __webpack_public_path__ + "img/icon_zahnarzt_termine.11063050.svg";